/** Inline výběr topicu z DB (Popover + cmdk). Nahrazuje ruční psaní topicu. */

import { Check, ChevronsUpDown } from "lucide-react";
import React, { useState } from "react";
import { useAllTopics } from "@client/hooks/useAllTopics";
import { cn } from "@client/lib/cn";
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from "@client/components/ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "@client/components/ui/popover";

const fmt = (v: unknown): string => {
  if (v === undefined || v === null) return "—";
  if (typeof v === "boolean") return v ? "true" : "false";
  return String(v);
};

export const TopicPicker: React.FC<{
  value?: string;
  onChange: (topic: string) => void;
  valueTypeFilter?: string[]; // např. ["FLOAT"]
  placeholder?: string;
  className?: string;
}> = ({ value, onChange, valueTypeFilter, placeholder = "Vyber veličinu…", className }) => {
  const [open, setOpen] = useState(false);
  const topics = useAllTopics();
  const list = valueTypeFilter ? topics.filter((t) => valueTypeFilter.includes(t.valueType)) : topics;
  const current = topics.find((t) => t.topic === value);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          className={cn("nodrag flex w-full items-center justify-between gap-2 rounded border border-input bg-background px-2 py-1 text-left text-xs", className)}
        >
          <span className={cn("truncate", !value && "text-muted-foreground")}>
            {value ? current?.nickname || value : placeholder}
          </span>
          <ChevronsUpDown className="h-3.5 w-3.5 shrink-0 opacity-50" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[min(28rem,90vw)] p-0" align="start">
        <Command
          filter={(itemValue, search) => (itemValue.toLowerCase().includes(search.toLowerCase()) ? 1 : 0)}
        >
          <CommandInput placeholder="Hledat veličinu / topic…" />
          <CommandList>
            <CommandEmpty>Nic nenalezeno.</CommandEmpty>
            {list.map((t) => (
              <CommandItem
                key={t.topic}
                value={`${t.nickname} ${t.topic} ${t.unit}`}
                onSelect={() => {
                  onChange(t.topic);
                  setOpen(false);
                }}
              >
                <Check className={cn("h-3.5 w-3.5 shrink-0", value === t.topic ? "opacity-100" : "opacity-0")} />
                <div className="flex min-w-0 flex-1 flex-col">
                  <span className="truncate font-medium">{t.nickname || t.topic}</span>
                  <span className="truncate font-mono text-[10px] text-muted-foreground">{t.topic}</span>
                </div>
                <span className="shrink-0 text-right text-[10px] text-muted-foreground">
                  {fmt(t.lastValue)} {t.unit}
                  <span className="ml-1 rounded bg-muted px-1">{t.valueType}</span>
                </span>
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};

export default TopicPicker;
